import type { WorkspaceAppManifest } from './workspaceManifest';

export const APP_MANIFEST = {
    appId: 'purchases',
    permissionsPrefix: 'purchases',
    displayName: 'Purchases',

    navSections: [
        { key: 'dashboard', label: 'Dashboard', route: '/purchases/dashboard' },
        { key: 'orders',    label: 'Orders',    route: '/purchases/orders' },
        { key: 'reporting', label: 'Reporting', route: '/purchases/reporting' },
    ],

    resources: [
        { key: 'purchaseOrders',       label: 'Purchase orders',               navSection: 'orders' },
        { key: 'purchaseRequisitions', label: 'RFQ',                           navSection: 'orders' },
        { key: 'inwardGatePasses',     label: 'GRN / Inward gate pass',        navSection: 'orders' },
        { key: 'purchaseInvoices',     label: 'Purchase invoices / Vendor bills', navSection: 'orders' },
        { key: 'purchaseReturns',      label: 'Purchase Returns',              navSection: 'orders' },
        { key: 'inwardGatePassPosting',  label: 'GRN — unpost',                navSection: 'orders' },
        { key: 'purchaseInvoicePosting', label: 'Purchase invoices — unpost',  navSection: 'orders' },
        { key: 'purchaseReturnPosting',  label: 'Purchase returns — unpost',   navSection: 'orders' },
        { key: 'purchaseRegisterReport', label: 'Purchase register report',    navSection: 'reporting' },
    ],
} satisfies WorkspaceAppManifest;
